/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp.  2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React from 'react';
import ReactDOM from 'react-dom';


class ExploreToolbarHelper  {
	constructor(options) {
		this.dashboardApi = options.dashboardApi;

		const settings = this.dashboardApi.getFeature('DashboardSettings');
		this._explorationToolBarRoot = settings && settings.get && settings.get('odtToolbarContainer');
		this._canvasToolbarRoot = settings && settings.get && settings.get('panelToolbarContainer');

		if( this._explorationToolBarRoot ) {
			const explorationToolbarRoot = this._getContainer();
			this._explorationToolBarRoot.appendChild(explorationToolbarRoot);
			this._explorationToolBarRoot = explorationToolbarRoot;
		}

		if( this._canvasToolbarRoot ) {
			const canvasToolbarRoot = this._getContainer();
			this._canvasToolbarRoot.appendChild(canvasToolbarRoot);
			this._canvasToolbarRoot = canvasToolbarRoot;
		}

	}

	_getContainer() {
		const container = document.createElement('div');
		container.className = 'explore-vis-toolbar';
		return container;
	}

	renderToolBar(toolBarComponent) {
		if(!this._mountedToolbar && this._explorationToolBarRoot) {
			this._mountedToolbar = true;
			ReactDOM.unmountComponentAtNode(this._explorationToolBarRoot);
			this._toolbar = ReactDOM.render(
				toolBarComponent,
				this._explorationToolBarRoot
			);
		}
	}

	renderCanvasToolBar(toolBarPanelComponent) {
		if(!this._mountedToolbarPanel && this._canvasToolbarRoot) {
			this._mountedToolbarPanel = true;
			ReactDOM.unmountComponentAtNode(this._canvasToolbarRoot);
			this._toolbarPanel = ReactDOM.render(
				toolBarPanelComponent,
				this._canvasToolbarRoot
			);
		}
	}

	unmountToolbar() {
		if(this._mountedToolbar) {
			this._mountedToolbar = false;
			ReactDOM.unmountComponentAtNode(this._explorationToolBarRoot);
		}
		if(this._mountedToolbarPanel) {
			this._mountedToolbarPanel = false;
			ReactDOM.unmountComponentAtNode(this._canvasToolbarRoot);
		}
	}

}

export default ExploreToolbarHelper;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreToolbarHelper.js